import React from 'react'

import { AccessPassDetails } from './AccessPassDetails'

import './viewAccessPassWrapper.scss'

export default function ViewAccessPassWrapper({ accessPassTemplate }) {
  return <AccessPassDetails accessPassTemplate={accessPassTemplate} />
}
